/* src/app/modals/create-channel-modal/create-channel-modal.component.scss */
.form-group {
  margin-bottom: 1.25rem;
}
.field-label {
  display: block;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  color: var(--text-color);
  margin-bottom: 0.25rem;
}
.name-input-wrapper {
  display: flex;
  align-items: center;
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  padding: 0 0.75rem;
  background-color: color-mix(in srgb, var(--surface-color) 50%, transparent);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  transition: border-color 0.15s ease, background-color 0.15s ease;
}
.name-input-wrapper:hover,
.name-input-wrapper:focus-within {
  border-color: color-mix(in srgb, var(--text-secondary-color) 40%, transparent);
}
.name-input-wrapper .hash-prefix {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  color: var(--text-color);
  margin-right: 0.25rem;
}
.name-input-wrapper input.channel-name-input {
  flex: 1;
  border: none;
  outline: none;
  padding: 0.625rem 0;
  font-family:
    "Inter",
    system-ui,
    sans-serif;
  font-size: 0.875rem;
  line-height: 1.25rem;
  background: transparent !important;
  -webkit-backdrop-filter: none;
  backdrop-filter: none;
  color: var(--text-color);
}
.name-input-wrapper input.channel-name-input::placeholder {
  color: color-mix(in oklab, var(--text-color) 65%, transparent);
}
.name-input-wrapper input.channel-name-input:hover,
.name-input-wrapper input.channel-name-input:focus {
  border-color: transparent !important;
  box-shadow: none !important;
}
.channel-description-input {
  width: 100%;
  padding: 0.625rem 0.75rem;
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  background-color: color-mix(in srgb, var(--surface-color) 50%, transparent);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  font-family:
    "Inter",
    system-ui,
    sans-serif;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--text-color);
  outline: none;
  resize: vertical;
  box-sizing: border-box;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}
.channel-description-input::placeholder {
  color: color-mix(in oklab, var(--text-color) 65%, transparent);
}
.channel-description-input:hover,
.channel-description-input:focus {
  border-color: color-mix(in srgb, var(--text-secondary-color) 40%, transparent);
  box-shadow: none;
}
.hint-text {
  font-size: 0.75rem;
  line-height: 1rem;
  color: var(--text-secondary-color);
  margin-top: 0.25rem;
}
.error-text {
  font-size: 0.75rem;
  line-height: 1rem;
  color: var(--color-danger);
  margin-top: 0.25rem;
}
.toggle-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.toggle-row .toggle-label {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  color: var(--text-color);
}
.toggle-row .toggle-label crwd-icon {
  width: 1rem;
  height: 1rem;
  color: var(--text-secondary-color);
}
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 2.75rem;
  height: 1.5rem;
  flex-shrink: 0;
}
.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.toggle-switch .toggle-slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: var(--border-color);
  border-radius: 9999px;
  border: 2px solid transparent;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1);
}
.toggle-switch .toggle-slider::before {
  content: "";
  position: absolute;
  height: 1.25rem;
  width: 1.25rem;
  top: 0;
  left: 0;
  background-color: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 9999px;
  transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1);
}
.toggle-switch input:checked + .toggle-slider {
  background-color: var(--color-accent);
}
.toggle-switch input:checked + .toggle-slider::before {
  transform: translateX(1.25rem);
}
.member-list {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  margin-top: 0.5rem;
}
.member-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1);
}
.member-item:hover {
  background: var(--surface-color);
}
.member-item.disabled {
  opacity: 0.5;
  cursor: default;
  pointer-events: none;
}
.member-item .member-name {
  flex: 1;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: var(--text-color);
}
.member-item .member-name .you-badge {
  font-size: 0.75rem;
  color: var(--text-secondary-color);
  font-weight: 400;
}
.member-item .member-checkbox {
  appearance: none;
  width: 1rem;
  height: 1rem;
  border: 1.5px solid var(--border-color);
  border-radius: 0.25rem;
  background: var(--background-color);
  cursor: pointer;
  flex-shrink: 0;
  display: grid;
  place-content: center;
  pointer-events: none;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1), border-color 150ms cubic-bezier(0.4, 0, 0.2, 1);
}
.member-item .member-checkbox::before {
  content: "";
  width: 0.55rem;
  height: 0.55rem;
  transform: scale(0);
  transition: transform 0.1s;
  background: var(--color-accent);
  clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
}
.member-item .member-checkbox:checked {
  border-color: var(--color-accent);
  background: var(--color-accent);
}
.member-item .member-checkbox:checked::before {
  transform: scale(1);
  background: #ffffff;
}
/*# sourceMappingURL=create-channel-modal.component-KRSHGRKA.css.map */
